//Footer Accordian
$(document).ready(function () {
	const $accordionHeaders = $('.footer-menu h5');
	if ($accordionHeaders.length === 0) {
		return;
	}

	$accordionHeaders.on('click', function () {
		const $this = $(this);
		if ($this.hasClass('active')) {
			$this.removeClass('active');
		} else {
			$accordionHeaders.removeClass('active');
			$this.addClass('active');
		}
	});
});

//Dropdown menu
$(document).ready(function () {
	var $menuItems = $(".desktop-menu-block .list-menu .list-menu-item");
	var $header = $(".header");
	var hideTimeout;

	$menuItems.on("mouseenter", function () {
		clearTimeout(hideTimeout);
		$menuItems.removeClass("active-menu");
		$(this).addClass("active-menu");

		if ($(this).find(".header-megamenu-block-main").length) {
			$("body").addClass("menu-main");
		}
	});

	$header.on("mouseleave", function () {
		hideTimeout = setTimeout(function () {
			$menuItems.removeClass("active-menu");
			$("body").removeClass("menu-main");
		}, 200);
	});

	$header.on("mouseenter", function () {
		clearTimeout(hideTimeout);
	});
});

//Dropdown Sub menu
$(function () {
	$('.desktop-menu-block .megamenu-sub-menu li').on('mouseenter', function () {
		const $parent = $(this).closest('.megamenu-block-wrapper');
		const tabId = $(this).data('tabid');

		$parent.find('.megamenu-sub-menu li').removeClass('active');
		$parent.find('.menu-wrapper').removeClass('show-menu');

		$(this).addClass('active');
		$parent.find('.menu-wrapper.' + tabId).addClass('show-menu');
	});
});

$(".mobile-menu-block .menu-drawer .list-menu-item.has-children").on("click", function (e) {
  // Ignore clicks inside submenu
  if ($(e.target).closest(".megamenu-sub-menu").length) {
    return;
  }

  e.preventDefault();

  // Remove active/show-menu from all submenu items
  $(".megamenu-sub-menu li").removeClass("active");
  $(".megamenu-sub-menu li .menu-wrapper").removeClass("show-menu");

  // Toggle main menu active state
  $(this).toggleClass("active-menu");
});

$(".mobile-menu-block .menu-drawer .list-menu-item.has-children .megamenu-block-wrapper .megamenu-sub-menu li.has-sub-children").on("click", function (e) {
	 if ($(e.target).closest(".menu-wrapper").length) {
    return;
  }
  e.preventDefault();

  $(this).toggleClass("active");
  $(this).find(".menu-wrapper").toggleClass("show-menu");
});

$(function () {
  $('.brand-list a').on('mouseenter', function () {
    const $parent = $(this).closest('.brand-product-wrapper');
    const tabId = $(this).data('tabid');

    $parent.find('.brand-list a').removeClass('active');
    $(this).addClass('active');

    $parent.find(".brands-product-list").hide();
    $parent.find(".brands-products-" + tabId).css("display", "flex");
  });

  $('.brand-product-wrapper').each(function () {
    const $firstLink = $(this).find('.brand-list a').first();
    const tabId = $firstLink.data('tabid');
    
    $firstLink.addClass('active');

    $(this).find(".brands-product-list").hide();
    $(this).find(".brands-products-" + tabId).css("display", "flex");
  });
});

// Mobile view in click Team issue subscription
$(document).ready(function () {
  $('#HeaderMenu-team-issue-subscription').on('click', function () {
    let $details = $('header-drawer details');
    let $summary = $('.header__icon--menu');
    let $classremove = $('body.gradient');
    
    $details.removeClass('menu-opening');
    $summary.attr('aria-expanded', 'false'); 
    $classremove.removeClass('overflow-hidden-tablet');
  });
});



// Filter
document.addEventListener('DOMContentLoaded', function () {
	var lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
	var filterItem = document.querySelector('.filter-item');

	function handleStickyFilter() {
		if (!filterItem) return;
		if (window.innerWidth <= 749) {
			// Mobile: use scroll direction
			// Initial state
			filterItem.classList.remove('up', 'down');
		} else {
			// Desktop: always down
			filterItem.classList.remove('up');
			filterItem.classList.add('down');
		}
	}

	function handleScroll() {
		if (!filterItem || window.innerWidth > 749) return;
		var st = window.pageYOffset || document.documentElement.scrollTop;
		if (st < lastScrollTop) {
			// Scrolling up
			filterItem.classList.add('up');
			filterItem.classList.remove('down');
		} else {
			// Scrolling down
			filterItem.classList.remove('up');
			filterItem.classList.add('down');
		}
		lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
	}

	handleStickyFilter();
	window.addEventListener('resize', handleStickyFilter);
	window.addEventListener('scroll', handleScroll);
});
function showHideFacetFiltersForm() {
	var windowWidth = $(window).width();
	if (windowWidth < 749) {
		$('.product-grid-container .desktop-version select[name="sort_by"]')
			.prop('disabled', true)
			.css('display', 'none');

		$('.product-grid-container .mobile-version select[name="sort_by"]')
			.prop('disabled', false)
			.css('display', 'block');
	} else {
		$('.product-grid-container .desktop-version select[name="sort_by"]')
			.prop('disabled', false)
			.css('display', 'block');

		$('.product-grid-container .mobile-version select[name="sort_by"]').prop('disabled', true).css('display', 'none');
	}
}

$(document).ready(function () {
	showHideFacetFiltersForm();
	$(window).on('resize', function () {
		showHideFacetFiltersForm();
	});
	// Re-run after AJAX content loads
	$(document).ajaxComplete(function () {
		showHideFacetFiltersForm();
	});
});

$(document).on('click', '.rebuy-product-actions, .rebuy-bundle-builder__cta-container', function (e) {
	if ($(e.target).closest(".rebuy-bundle-builder__product-quantity").length) {
    return;
  }
	setTimeout(function () {
		fetch(`${routes.cart_url}`)
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(responseText, 'text/html');
				const selectors = ['.header__icon--cart', '.cart-drawer', 'cart-drawer-items', '.drawer__footer', '.item-count'];
				for (const selector of selectors) {
					const targetElement = document.querySelector(selector);
					const sourceElement = html.querySelector(selector);
					if (targetElement && sourceElement) {
						targetElement.replaceWith(sourceElement);
					}
				}
				$('.drawer__inner-empty').remove()
				$('cart-drawer.drawer').removeClass('is-empty')
				$('cart-drawer.drawer').addClass('active')
			})
			.catch((e) => {
				console.error(e);
			});
	}, 1200)
});
document.addEventListener('DOMContentLoaded', function () {
	// Function to reinitialize Rebuy
	function reinitializeRebuy() {
		if (typeof Rebuy !== 'undefined' && Rebuy.init) {
			Rebuy.init(); // Adjust this based on Rebuy’s actual API method
		}
	}

	setInterval(() => {
		reinitializeRebuy();
	}, 1000);
});

function checkSubscriptionOptionsInAllBlocks() {
	const subscriptionData = [];

	$('.home-section-featured-product .block__card-product-recharge').each(function () {
		const $block = $(this);
		const $subscribeRadio = $block.find('.subscribe_product.subscribe_product-multiple:checked');

		if ($subscribeRadio.length > 0) {
			const $selectBox = $block.find('.selling_plan_dropdown');
			if ($selectBox.length > 0) {
				const $selectedOption = $selectBox.find('option:selected');

				// Extract values
				const sellingPlanId = $selectedOption.val();
				const discountPrice = $selectedOption.data('discount-price');
				const discountPercentage = $selectedOption.data('discount-percentage');

				// Update input[name="selling_plan"]
				const $productForm = $block.closest('.product__info-wrapper');
				const $sellingPlanInput = $productForm.find('input[name="selling_plan"]');
				if ($sellingPlanInput.length > 0) {
					$sellingPlanInput.val(sellingPlanId);
				}

				// Update text elements
				const $discountedPriceText = $block.find('.subscribe--discounted-price');
				const $discountPercentageText = $block.find('.selected_discount_value');

				if ($discountedPriceText.length > 0) {
					$discountedPriceText.text(discountPrice);
				}
				if ($discountPercentageText.length > 0) {
					$discountPercentageText.text(discountPercentage + '%');
				}

				// Store data
				subscriptionData.push({
					sellingPlanId,
					discountPrice,
					discountPercentage
				});
			}
		} else {
			const $productForm = $block.closest('.product__info-wrapper');
			const $sellingPlanInput = $productForm.find('input[name="selling_plan"]');
			if ($sellingPlanInput.length > 0) {
				$sellingPlanInput.val("");
			}
		}
	});
}

$(document).ready(function () {
	checkSubscriptionOptionsInAllBlocks();

	$(document).on('change', '.home-section-featured-product .subscribe_product', function () {
		checkSubscriptionOptionsInAllBlocks();
	});

	$(document).on('change', '.home-section-featured-product .selling_plan_dropdown', function () {
		checkSubscriptionOptionsInAllBlocks();
	});
});



$(".graphics-slider-main").slick({
	slidesToShow: 4,
	infinite: false,
	slidesToScroll: 1,
	autoplay: true,
	autoplaySpeed: 2000,
	arrows: true,
	responsive: [
		{
			breakpoint: 991,
			settings: {
				slidesToShow: 2,
			}
		},
		{
			breakpoint: 501,
			settings: {
				slidesToShow: 1,
			}
		}
	]
});